'use client'

import { useEffect } from 'react'
import Intercom, { shutdown, hide, show } from '@intercom/messenger-js-sdk'
import useRoles from '@wiggot/auth/hooks/useRoles'
import { useSession } from '@wiggot/auth/hooks/useSession'
import { INTERCOM_LAUNCHER_BUTTON_ID } from '../constants/intercom-id'

export const IntercomProvider = ({
  appId,
  stage,
  isLanding
}: {
  appId: string
  stage: string
  isLanding?: boolean
}) => {
  const { profile } = useSession()
  const { isAdvance, isAdminAgency, isBrokerWithAgency } = useRoles()

  const getUserType = () => {
    if (isAdminAgency) {
      return 'Admin agency'
    }
    if (isBrokerWithAgency) {
      return 'Broker agency'
    }
    return 'Broker independent'
  }

  const getUserFree = () => {
    return isAdvance ? 'false' : 'true'
  }

  const initializeIntercom = () => {
    if (stage === 'prod') {
      if (profile && !isLanding) {
        Intercom({
          app_id: appId,
          user_id: `${profile?.userId}`,
          hide_default_launcher: true,
          custom_launcher_selector: INTERCOM_LAUNCHER_BUTTON_ID,
          user: profile?.userFullname,
          name: profile?.userFullname,
          email: profile?.email,
          phone: profile?.phoneNumber,
          kind: window.location.pathname,
          userType: getUserType(),
          free: getUserFree()
        })
        eventOnReceiveMessage()
        return
      }
      Intercom({
        app_id: appId,
        hide_default_launcher: true
      })
      eventOnReceiveMessage()
    }
  }

  const eventOnReceiveMessage = () => {
    // eslint-disable-next-line prettier/prettier
    (window as any).Intercom(
      'on',
      'unreadCountChange',
      (unreadCount: number) => {
        if (unreadCount > 0) {
          show() // Abre el widget si hay mensajes sin leer
        }
      }
    )
  }

  useEffect(() => {
    initializeIntercom()
  }, [profile])

  const handleClickOutside = (event: any) => {
    const intercomFrame = document.querySelector(
      'iframe.intercom-launcher-frame'
    )
    if (intercomFrame && !intercomFrame.contains(event.target)) {
      hide()
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside)

    return () => {
      document.removeEventListener('click', handleClickOutside)
      shutdown()
    }
  }, [])
  return <></>
}

export default IntercomProvider
